import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Notifications, { notify } from '@kyvg/vue3-notification';
import router from './router';
import { ValidationRules } from '@swpsoftware/vue-components';
import deMessages from 'devextreme/localization/messages/de.json';
import { loadMessages, locale } from 'devextreme/localization';
import { startApplication, ErrorNotification, Notify } from '@swpsoftware/commons-vue';

import './index.scss';
import '@swpsoftware/vue-components/dist/assets/dx.material.vibim-color.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@swpsoftware/vue-components/dist/style.css';
import '@swpsoftware/commons-layout/dist/style.css';

import './vibim.css';
import App from './App.vue';
import { showErrorNotification } from '@/services/ErrorNotificationHelper';
import { registerDxLicense } from '@/utils/DxHelper';
import { ApiConfig } from '@swpsoftware/commons-api';

startApplication(() => {
  ApiConfig.setup();

  const app = createApp(App).use(router).use(createPinia()).use(Notifications);

  registerDxLicense();

  Notify.setNotifier({ notify });
  ErrorNotification.registerErrorHandler(window, app);

  app.config.errorHandler = (error: unknown) => {
    if (
      error instanceof Error &&
      (error.message.includes('$_templatesManager') || error.message.includes('discover'))
    ) {
      return; // dx internal error that happens in dev mode, introduced with vue version 3.5
    }
    console.info(error);
    showErrorNotification(error);
  };

  window.onerror = function (message, source, line, column, error: unknown) {
    if (!source) {
      return;
    }
    showErrorNotification(error);
  };

  loadMessages(deMessages);
  locale('de-DE');

  ValidationRules.register();

  app.mount('#app');
});
